export const orchestratorConstants = {
  UPDATE_INVENTORY_PRESETS: "df-update-inventory-preset-orchestrator",
  IMPORT_INVENTORY: "df-inventory-import-orchestrator",
  MIGRATE_SHOPIFY_LOCATION: "df-migrate-shopify-location-orchestrator",
};
